import React, { FC, forwardRef, useEffect, useMemo, useState } from 'react';
import { Category } from 'shared/types/product';
import { useFormat } from 'helpers/hooks/useFormat';
import { useProductList } from '../../context';

interface Props {
  categories: Category[];
}

const SortFacet: FC<React.PropsWithChildren<Props>> = forwardRef((props, ref?: any) => {
  const categories: Category[] = props.categories;
  const [isCert, setIsCert] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const currentPath = window.location.pathname;
      const isCert = currentPath.includes('promotion-club-free-ecard') || currentPath.includes('certification-card');
      setIsCert(isCert);
    }
  }, []);

  let elearningCategoryId = '';
  categories?.some((category) => {
    if (category.slug == 'course-type') {
      category?.subCategories?.some((subCategory) => {
        if (subCategory.slug == 'elearning-course-type') {
          if (subCategory?.categoryId) elearningCategoryId = subCategory.categoryId;
          return;
        }
      });
      return;
    }
  });

  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });
  const { replaceSort, activeSort } = useProductList();

  const options = useMemo<Array<{ label: string; attribute: string; value: 'asc' | 'desc' }>>(() => {
    const sort = [
      {
        label: formatProductMessage({ id: 'most.popular', defaultMessage: 'Most Popular' }),
        // attribute: 'categoryOrderHints.b3bf462d-19b8-4df1-a8ba-cbf4602e2b66',
        attribute: `categoryOrderHints.${elearningCategoryId}`,
        value: 'asc' as const,
      },
      {
        label: formatProductMessage({ id: 'name.az', defaultMessage: 'Name a-z' }),
        attribute: 'name.en',
        value: 'asc' as const,
      },
      {
        label: formatProductMessage({ id: 'name.za', defaultMessage: 'Name z-a' }),
        attribute: 'name.en',
        value: 'desc' as const,
      },
    ];
    if (!isCert) {
      sort.splice(
        1,
        0,
        {
          label: formatProductMessage({ id: 'price.low.high', defaultMessage: 'Price Low to High' }),
          attribute: 'price',
          value: 'asc' as const,
        },
        {
          label: formatProductMessage({ id: 'price.high.low', defaultMessage: 'Price High to Low' }),
          attribute: 'price',
          value: 'desc' as const,
        },
      );
    }
    return sort;
  }, [elearningCategoryId, formatProductMessage, isCert]);

  return (
    <div data-id="sort-facet">
      {options.map(({ label, attribute, value }, index) => (
        <div
          data-id={`sort-option-${index}`}
          key={`${attribute}-${index}`}
          className={`cursor-pointer p-14 transition hover:bg-neutral-200 ${
            attribute === activeSort?.attribute ? 'bg-neutral-200' : 'bg-transparent'
          }`}
          onClick={() => replaceSort({ attribute, value })}
        >
          {label}
        </div>
      ))}
    </div>
  );
});

export default SortFacet;
SortFacet.displayName = 'SortFacet';
